import MenuIcon from "@mui/icons-material/Menu";
import { Box, Button, ButtonBase, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import modelings from "../../../data/c4/modelings.data";
import baseModel from "../data/baseModel.data";
import useModels from "../hooks/useModels";
import useSelectedMenuStore from "../stores/useSelectedMenuStore";
import useViewerStore from "../stores/useViewerStore";
// import LogoHeader from "./LogoHeader";
import c4Data from "../../../data/k-projects/c4.data";
import { DownArrow } from "../../../icons";
import c4Pins from "../data/c4Pins.data";
import useBaseModel from "../hooks/useBaseModel";
import useC4Boundary from "../hooks/useC4Boundary";
import usePanoramaClick from "../hooks/usePanoramaClick";
import usePanoramaPins from "../hooks/usePanoramaPins";
import useSelectModels from "../hooks/useSelectModels";
import usePanoramaPopupStore from "../stores/usePanoramaPopupStore";
import MasterPlanMenu from "./MasterPlanMenu";
import PanoramaPopup from "./PanoramaPopup";

// const sx1 = {
//   color: "white",
//   width: 255,
//   height: "100dvh",
//   backgroundColor: "rgba(0, 0, 0, 0.75)",
//   flexDirection: "column",
//   alignItems: "center",
//   paddingX: "12px",
//   minHeight: "500px",
//   overflowY: "auto",
//   msOverflowStyle: "none", // 스크롤 숨김
//   scrollbarWidth: "none", // 스크롤 숨김
// };

const titleStyle = {
  width: "100%",
  marginTop: "24px",
  fontFamily: "Arimo",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "30px",
  lineHeight: "22px",
  letterSpacing: "-0.43px",
  color: "#747474",
  cursor: "pointer",
};

const backgroundStyle = {
  borderRadius: "5px",
  border: "solid 1px white",
  marginBottom: "8px",
};

const hamburgerIconStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
  marginTop: "15px",
  flexDirection: "column",
  justifyContent: "space-between",
  backgroundColor: "rgba(0, 0, 0, 0.75)",
  padding: "7px 19px 30px 19px",
  marginLeft: "5px",
  borderRadius: "50%",
};

function KProjectText() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: "16px",
        width: "100%",
      }}
    >
      <br />
      <Typography
        key={"k-project"}
        sx={{
          fontFamily: "Arimo",
          fontStyle: "normal",
          fontWeight: 700,
          fontSize: "20px",
          lineHeight: "22px",
          letterSpacing: "-0.43px",
          color: "#FFFFFF",
          paddingBottom: "30px",
        }}
      >
        C4 Site
      </Typography>
    </Box>
  );
}

function useC4Menu() {
  const { selectedMenu } = useSelectedMenuStore();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (selectedMenu === "C4") {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [selectedMenu]);

  useC4Boundary({
    show: isOpen,
  });

  usePanoramaPins({ items: c4Pins, show: isOpen });
}

function useBM() {
  const { setBaseModel } = useViewerStore();

  React.useEffect(() => {
    setBaseModel({
      path: baseModel.path,
      adjustHeight: baseModel.adjustHeight,
    });

    return () => {
      setBaseModel();
    };
  }, [setBaseModel]);

  useBaseModel();
}

function useKSS() {
  const { selectedMenu } = useSelectedMenuStore();
  const { setModels } = useViewerStore();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (selectedMenu === "KSS") {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [selectedMenu]);

  React.useEffect(() => {
    if (!isOpen) {
      setModels([]);
    } else {
      // setModels([modelings[1]]);
      setModels(modelings);
    }
  }, [isOpen, setModels]);

  useModels();
  useSelectModels();
}

export default function Drawer() {
  usePanoramaClick();
  const { selectedMenu, setSelectedMenu } = useSelectedMenuStore();
  const [folder, setFolder] = useState(false);
  // const [val, setVal] = useState<string>("");

  const { setPhase } = useViewerStore();
  const { closePopup } = usePanoramaPopupStore();

  // useEffect(() => {
  //   if (val.length > 0) {
  //     console.log("val", val);
  //     setPhase(JSON.parse(val));
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [val]);

  useEffect(() => {
    const handleResize = () => {
      // 모바일 화면 크기 기준 (예: 768px 이하)
      if (window.innerWidth <= 768) {
        setFolder(true);
      }
    };

    // 페이지 처음 접속 시 화면 크기 체크
    handleResize();
  }, []);

  // 베이스모델
  useBM();
  // c4 메뉴
  useC4Menu();
  // kss 메뉴
  useKSS();

  return (
    <div style={{ position: "absolute", top: 0, left: 0, zIndex: 100 }}>
      {!folder ? null : (
        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "flex-start" }}
        >
          <ButtonBase
            sx={hamburgerIconStyle}
            onClick={() => {
              setFolder(false);
            }}
          >
            <MenuIcon sx={{ color: "white" }} />
          </ButtonBase>
        </Box>
      )}
      <Box
        sx={{
          color: "white",
          width: 255,
          height: "100dvh",
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          flexDirection: "column",
          alignItems: "center",
          paddingX: "12px",
          minHeight: "500px",
          overflowY: "auto",
          msOverflowStyle: "none", // 스크롤 숨김
          scrollbarWidth: "none", // 스크롤 숨김
          display: folder ? "none" : "flex",
        }}
      >
        {/* ------- 헤더 Start ------- */}
        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "flex-start" }}
        >
          <ButtonBase
            sx={{
              width: "24px",
              height: "24px",
              display: "flex",
              paddingTop: "22px",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
            onClick={() => {
              setFolder(true);
            }}
          >
            <MenuIcon sx={{ color: "white" }} />
          </ButtonBase>
          <Typography key={"typo"} sx={titleStyle}>
            &nbsp;Spatial Log
          </Typography>
        </Box>

        {/* ------- K-project Start ------- */}
        <KProjectText />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            rowGap: "16px",
            width: "100%",
            justifyContent: "flex-end",
          }}
        >
          <Box sx={backgroundStyle}>
            <Button
              sx={{
                padding: "0px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "100%",
                color: selectedMenu === "C4" ? "yellow" : "white",
              }}
              onClick={() => {
                closePopup();
                if (selectedMenu === "C4") {
                  setSelectedMenu("NOTHING");
                } else {
                  setSelectedMenu("C4");
                  setPhase(c4Data.PanoramaVm.phase); // 1
                }
              }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <Typography
                  sx={{
                    size: "14px",
                    lineHeight: "22px",
                    letterSpacing: "-0.43px",
                    fontWeight: "700",
                  }}
                >
                  C4 RFP
                </Typography>
                <DownArrow
                  sx={{ marginLeft: "auto", width: "30px", height: "30px" }}
                />
              </Box>
              <Typography sx={{ fontSize: "10px" }}> 2025.03 </Typography>
            </Button>
          </Box>

          {/* <MasterPlanMenu setVal={setVal} val={val} /> */}
          <MasterPlanMenu />
        </Box>
      </Box>

      <PanoramaPopup />
    </div>
  );
}
